<mat-expansion-panel class="mat-elevation-z1" [expanded]="expanded">
  <mat-expansion-panel-header style="background-color: whitesmoke;">
    <mat-panel-title class="avenir-font text-nowrap">
      {{ label }}
    </mat-panel-title>
    <mat-panel-description class="justify-content-end">
      <mat-icon [ngStyle]="{'color': items.length > 0 ? '#9E81E4' : '#999'}">{{ iconName }}</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="pt-4">
    <mat-form-field class="w-100" appearance="fill" subscriptSizing="dynamic" floatLabel="always">
      <mat-label class="avenir-font">{{ label }}</mat-label>
      <mat-chip-grid #chipList>
        <mat-chip *ngFor="let item of items"  [removable]="true" (removed)="remove(item)"  class="custom-chip">
          <small class="avenir-font">{{ item|truncate:30 }}</small>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        <input
          #input
          placeholder="{{ placeholder }}"
          [formControl]="inputControl"
          [matChipInputFor]="chipList"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)"
        >
      </mat-chip-grid>
    </mat-form-field>
  </div>
</mat-expansion-panel>
